export default "__VITE_ASSET__57ce26c4__"